// extracted by mini-css-extract-plugin
export default {"dash-spacing":"ToothRange_dash-spacing__R2mnz"};